import React, { createContext, useContext } from "react";
import { useMessageInvoices, useCreateMessageInvoice } from "hooks/v1/pages/system-setting/useMassageInvoices"; // Update this path if necessary

// Membuat context untuk loading
const MessageInvoiceContext = createContext();

// Provider untuk context loading
export const MessageInvoiceProvider = ({ children }) => {
  const messageInvoiceHook = useMessageInvoices();
  console.log("messageInvoiceHook", messageInvoiceHook);
  const createMessageInvoiceHook = useCreateMessageInvoice({
    messageInvoices: messageInvoiceHook.messageInvoices,
    setMessageInvoices: messageInvoiceHook.setMessageInvoices,
  });

  const contextValue = {
    ...messageInvoiceHook,
    ...createMessageInvoiceHook,
  };

  return (
    <MessageInvoiceContext.Provider value={contextValue}>
      {children}
    </MessageInvoiceContext.Provider>
  );
};

// Hook untuk mengakses context loading
export const useMessageInvoice = () => {
  const context = useContext(MessageInvoiceContext);
  console.log("context", context);

  if (!context) {
    throw new Error(
      "useMessageInvoice must be used within a MessageInvoiceProvider"
    );
  }

  return context;
};
